export default function numberFormat(value) {
    return new Intl.NumberFormat('default', {
        style: 'currency',
        currency: 'MAD'
    }).format(value);
}